"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageHSZS = void 0;
var react_1 = __importDefault(require("react"));
var crumbs_1 = require("../crumbs");
var layout_1 = require("./shared/layout");
var mini_time_chart_1 = require("./shared/mini_time_chart");
var zszdbar_1 = require("../quote/zszdbar");
var title_1 = require("./shared/title");
var middle_1 = require("../quotetable/middle");
/**
 * 沪深京指数页面
 * @returns
 */
function PageHSZS() {
    return (react_1.default.createElement("div", { className: "pagebankuai" },
        react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, null),
        react_1.default.createElement(layout_1.Layout4, { mt: 5 },
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "1.000001", height: 193, link: true }, "\u4E0A\u8BC1\u6307\u6570")),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "0.399001", height: 193, link: true }, "\u6DF1\u6210\u6307\u6570")),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "0.399006", height: 193, link: true }, "\u521B\u4E1A\u6307\u6570")),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "0.399330", height: 193, link: true }, "\u6DF1\u8BC1100"))),
        react_1.default.createElement(zszdbar_1.ZSZDBar, null),
        react_1.default.createElement(layout_1.Layout4, { mt: 10 },
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "1.000300", height: 193, link: true }, "\u6CAA\u6DF1300")),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "1.000016", height: 193, link: true }, "\u4E0A\u8BC150")),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "1.000003", height: 193, link: true }, "B\u80A1\u6307\u6570")),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "1.000680", height: 193, link: true }, "\u79D1\u521B\u7EFC\u6307"))),
        react_1.default.createElement(title_1.Title1, { mt: 10 },
            react_1.default.createElement(title_1.Title1.Main, null, "\u6CAA\u6DF1\u91CD\u8981\u6307\u6570")),
        react_1.default.createElement(middle_1.QuoteTableMiddle, { fs: 'b:MK0010',
            count: 50,
            table_key: 'Normal1',
            order: '',
            orderdur: 1 }),
        react_1.default.createElement(title_1.Title1, { mt: 10 },
            react_1.default.createElement(title_1.Title1.Main, null,
                react_1.default.createElement("a", { href: "./gridlist.html#index_sh" }, "\u4E0A\u8BC1\u7CFB\u5217\u6307\u6570"))),
        react_1.default.createElement(middle_1.QuoteTableMiddle, { fs: 'm:1+t:1',
            count: 5,
            table_key: 'Normal1',
            order: 'f3',
            orderdur: 1 }),
        react_1.default.createElement(middle_1.QuoteTableMiddleMore, null,
            react_1.default.createElement("a", { href: "./gridlist.html#index_sh" }, "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u4E0A\u8BC1\u7CFB\u5217\u6307\u6570>>")),
        react_1.default.createElement(title_1.Title1, { mt: 10 },
            react_1.default.createElement(title_1.Title1.Main, null,
                react_1.default.createElement("a", { href: "./gridlist.html#index_sz" }, "\u6DF1\u5733\u7CFB\u5217\u6307\u6570"))),
        react_1.default.createElement(middle_1.QuoteTableMiddle, { fs: 'm:0+t:5',
            count: 5,
            table_key: 'Normal1',
            order: 'f3',
            orderdur: 1 }),
        react_1.default.createElement(middle_1.QuoteTableMiddleMore, null,
            react_1.default.createElement("a", { href: "./gridlist.html#index_sz" }, "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u6DF1\u5733\u7CFB\u5217\u6307\u6570>>"))));
}
exports.PageHSZS = PageHSZS;
